export function track(event, properties) {
  analytics.track(
    event,
    properties
  )
}
